import { coreAgent } from "../../app/api/agent";
import { ProgramTypeDto } from "./dtos/ProgramTypeDto";

export const getProgramTypesRequest = () =>
  coreAgent.getRequest<ProgramTypeDto[]>("/programTypes");
